import { footerLinks } from '../lists/footer'

const Footer = () => {
    return (
        <footer className="flex w-full bg-[rgba(0,0,0,0.10)] px-8 py-4">
            <div className="ml-[8px] flex w-full items-center">
                <div className="mr-10 flex items-center justify-start text-sm font-semibold text-white opacity-80">
                    {`© ${new Date().getFullYear()} GIPHY Inc`}
                </div>
                <div className="h-6 w-0.5 min-w-[2px] bg-white opacity-30" />
                <div className="ml-10 flex items-center justify-start gap-6">
                    {footerLinks.map((link, idx) =>
                        link.onClick ? (
                            <button
                                key={idx}
                                type="button"
                                onClick={link.onClick}
                                className="cursor-pointer border-none bg-transparent text-sm text-white opacity-70 transition-opacity hover:opacity-100"
                            >
                                {link.label}
                            </button>
                        ) : (
                            <a
                                key={idx}
                                href={link.href}
                                className="text-sm text-white opacity-70 transition-opacity hover:opacity-100"
                            >
                                {link.label}
                            </a>
                        )
                    )}
                </div>
            </div>
        </footer>
    )
}

export default Footer
